<template>
  <span
    v-if="category && category.name"
    class="category-badge"
    :style="{ '--category-color': category.color }"
  >
    {{ category.name }}
  </span>
</template>

<script setup lang="ts">
import { type PropType } from 'vue'

defineProps({
  category: {
    type: Object as PropType<{ name: string, color: string } | null>,
    required: false,
    default: null
  }
})
</script>

<style scoped>
.category-badge {
  display: inline-block;
  padding: 1px 6px;
  line-height: 1.3;
  border-radius: 3px;
  font-size: inherit;
  font-weight: normal;
  white-space: nowrap;
  color: #000000;
  background-color: var(--category-color);
  border: 1px solid color-mix(in srgb, var(--category-color) 90%, #000000);
}
</style>
